import { __read } from "tslib";
import React, { useRef, useState } from 'react';
import { RcResponsiveContext, useRcPortalWindowContext, useResizeObserver, useTheme, useThemeProps, } from '../../foundation';
import { getMatchedBreakpoint } from './utils';
var RcResponsive = function (inProps) {
    var props = useThemeProps({ props: inProps, name: 'RcResponsive' });
    var theme = useTheme();
    var children = props.children, responsiveTarget = props.responsiveTarget, resizeThrottle = props.resizeThrottle, _a = props.breakpointMap, breakpointMap = _a === void 0 ? theme.breakpoints.values : _a;
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var currentWindow = externalWindow !== null && externalWindow !== void 0 ? externalWindow : window;
    var bodyRef = useRef(currentWindow.document.body);
    var targetRef = responsiveTarget !== null && responsiveTarget !== void 0 ? responsiveTarget : bodyRef;
    var _b = __read(useState(function () {
        var target = targetRef.current;
        if (target) {
            var width = target.clientWidth;
            return getMatchedBreakpoint(width, breakpointMap);
        }
        return;
    }), 2), contextValue = _b[0], setContextValue = _b[1];
    useResizeObserver(targetRef, function () {
        if (!targetRef.current)
            return;
        var width = targetRef.current.clientWidth;
        var matchedBreakpoint = getMatchedBreakpoint(width, breakpointMap);
        setContextValue(matchedBreakpoint);
    }, { mode: 'throttle', time: resizeThrottle });
    return (React.createElement(RcResponsiveContext.Provider, { value: contextValue }, children));
};
RcResponsive.defaultProps = {
    resizeThrottle: 200,
};
RcResponsive.displayName = 'RcResponsive';
export { RcResponsive };
